// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-avenue -> weidner-apartment-homes-avenue -> tuscany-at-faudree
// Generated: 2026-10-27T17:07:32.938Z
// Counts: 1 design, 37 content, 24 slot group, 1 collection binding, 11 section, 0 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  }
};

export const contentOverrides = {
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.bedroom_list_type": {
    "overrideType": "VALUE",
    "customValue": "derived",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_full_address"
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "<p>All Rights Reserved. <span data-type=\"field-token\" data-field=\"property_name\"></span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_interactivemap_blurb"
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": "virtual tour",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_name"
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=48/company/5726763346821120/019d0198-4291-7593-82c0-efd4c864db24.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "apartment-sync-loader.inject_dni_classes": {
    "overrideType": "VALUE",
    "customValue": "true",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Contact Us",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "cort-lead-form.form_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_cort_lead_form_id"
  },
  "facebook-pixel.pixel_ids": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_pixel_id"
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Browse the photo gallery to get a closer look at Tuscany at Faudree Apartment Homes in Odessa. See the apartment interiors, featuring open-concept layouts with natural light-filled spaces and granite countertops, along with community features such as the pool and spa, media center, and courtyard. These images offer a preview of the atmosphere and details you can expect when you visit in person.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "header.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "petpolicy.restrictions": {
    "overrideType": "VALUE",
    "customValue": "<ul><li><p>Pit Bull &amp; Pit Bull Mixes</p></li><li><p>American Pit Bull Terrier</p></li><li><p>American Staffordshire Terrier</p></li><li><p>Wolf Hybrids</p></li><li><p>Doberman Pinscher</p></li><li><p>Saint Bernard</p></li><li><p>American Bulldog</p></li><li><p>Staffordshire Bull Terrier</p></li><li><p>Rottweiler</p></li><li><p>German Shepherd</p></li><li><p>Chow Chow</p></li><li><p>Great Dane</p></li><li><p>Akita</p></li></ul><p></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "scheduletourform.form.thank_you_url": {
    "overrideType": "VALUE",
    "customValue": "/thank-you",
    "generatedValue": null,
    "mappedField": null
  },
  "amenities-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>At Tuscany at Faudree Apartment Homes, amenities are designed to support your daily routine both at home and throughout the community. Inside your apartment, enjoy modern kitchens with granite countertops and stainless steel appliances, plus convenient features like in-home laundry and walk-in closets. Throughout the community, you will find spaces to relax, like the spa and community garden, as well as areas to stay active and connect, like the 24-hour fitness center and resident lounge.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Do you have questions, or are you ready to learn more about Tuscany at Faudree Apartments in Odessa, TX? Our leasing team is here to help with availability, tours, and community details. Reach out by phone or online, and we will help you find the right Odessa apartment.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Tuscany at Faudree Apartments offers 1, 2, and 3-bedroom layouts designed for everyday comfort. Each home includes features like stainless steel appliances, walk-in closets, and functional living spaces that support your routine. Whether you are working from home or relaxing at the end of the day, these thoughtfully designed apartments provide the space you need.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "frc-hero.title": {
    "overrideType": "VALUE",
    "customValue": "Future Residents Club",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Tuscany at Faudree Apartments places you in a convenient Odessa location close to everyday essentials and local destinations. Enjoy nearby shopping, dining, and entertainment, including Cinergy Odessa, Market Street, and Music City Mall. With access to Highway 191, Highway 338, and Interstate 20, commuting around Odessa and beyond is straightforward. The University of Texas Permian Basin is about five minutes away, and Midland International Air and Space Port is within a 15-minute drive. Major employers like Haliburton are also nearby, making your daily commute easier.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Welcome to Tuscany at Faudree Apartments in Odessa, Texas. Located in northeast Odessa, near Cinergy Odessa, Market Street, and Music City Mall, this community offers a comfortable, connected place to live. Enjoy thoughtfully designed apartments with features like stainless steel appliances, built-in speakers, and an electric fireplace. With pet-friendly living, flexible lease terms, and quick access to TX-191, everyday living feels simple and convenient.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Plan your visit to Tuscany at Faudree Apartments in Odessa, Texas. Tour 1, 2, and 3-bedroom apartments featuring walk-in closets and an electric fireplace, and explore community amenities like the resort-style pool and 24-hour fitness center. Choose a virtual tour or schedule an in-person visit with a leasing team member who can guide you through the community and answer your questions.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p>Explore Tuscany at Faudree Apartments through a convenient virtual tour experience. View apartment layouts, get a feel for the community, and see what daily life could look like, all from your own device. When you are ready, you can also connect with a leasing team member for a guided virtual visit or schedule an in-person tour.</p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "contactform.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.repli360.com"
      }
    }
  },
  "footer.powered_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/5715369763274752/019d01a1-3f7d-77af-9dea-e6206da4f134.webp"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://www.multihub.io"
      }
    }
  },
  "header.schedule_tour_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/schedule-a-tour"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 5,
    "fieldOverrides": null
  },
  "footer.love_notes_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3412-75a9-9aac-8f5678cb59df.webp"
      }
    }
  },
  "footer.weidner_cares_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5726763346821120/019d44f3-3452-767e-8966-83b6939f057f.webp"
      }
    }
  },
  "footer.youtube_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.youtube.com/@WeidnerApartmentHomes"
      }
    }
  },
  "header.apply_now_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_apply_now_url"
      },
      "_target": {
        "type": "VALUE",
        "customValue": "_blank"
      }
    }
  },
  "header.resident_access_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_resident_portal_url"
      }
    }
  },
  "_template:hyperlocal::hyperlocalhero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "FIELD_MAPPING",
        "mappedField": "property_featured_image"
      }
    }
  },
  "amenities-hero.bg_image": {
    "sourceIndex": 22,
    "fieldOverrides": null
  },
  "contact-hero.bg_image": {
    "sourceIndex": 15,
    "fieldOverrides": null
  },
  "ctasection.card3_image": {
    "sourceIndex": 0,
    "fieldOverrides": null
  },
  "floor-plans-hero.bg_image": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0217-8f93-710a-957f-379a2f64f86f.webp"
      }
    }
  },
  "gallery-hero.bg_image": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "hero.bg_image": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167129/019d0216-ce2e-706c-be11-ca158af76026.webp"
      }
    }
  },
  "neighborhood-hero.bg_image": {
    "sourceIndex": 28,
    "fieldOverrides": null
  },
  "pet-policy-hero.bg_image": {
    "sourceIndex": 31,
    "fieldOverrides": null
  },
  "schedule-tour-hero.bg_image": {
    "sourceIndex": 30,
    "fieldOverrides": null
  },
  "socialfollow.yelp_link": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "https://www.yelp.com/biz/tuscany-at-faudree-apartment-homes-odessa-3?osq=Tuscany+at+Faudree+Apartment+Homes"
      }
    }
  },
  "specialofferbanner.offer": {
    "sourceIndex": null,
    "fieldOverrides": {
      "description": {
        "type": "VALUE",
        "customValue": "<p>$1250 off your first full month on select units! *Limited time offer, specials, pricing and availability subject to change daily. Contact the leasing office for details.</p>"
      }
    }
  },
  "virtual-tour-hero.bg_image": {
    "sourceIndex": 16,
    "fieldOverrides": null
  }
};

export const collectionBindingOverrides = {
  "gallery.images": {
    "limit": null,
    "hiddenIds": [
      "ec_89ae3990a9208240de7866f2"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      1
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "apartment-sync-loader",
      "blockId": "apartment-sync-loader",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "cort-lead-form",
      "blockId": "cort-lead-form",
      "position": 0
    },
    {
      "sectionId": "facebook-pixel",
      "blockId": "facebook-pixel",
      "position": 0
    },
    {
      "sectionId": "rentcafe-chatbot",
      "blockId": "rentcafe-chatbot",
      "position": 0
    },
    {
      "sectionId": "rentgrata-widget",
      "blockId": "rentgrata-widget",
      "position": 0
    }
  ],
  "accessibility": [
    {
      "sectionId": "audioeye-accessibility",
      "blockId": "audioeye-accessibility",
      "position": 11
    }
  ],
  "interactive-map": [
    {
      "sectionId": "apartment-sync-map",
      "blockId": "apartment-sync-map",
      "position": 11
    }
  ]
};

export const styleOverrides = {};
